import { Search } from 'lucide-react'

type NoResultsProps = {
  title?: string
  description?: string
}

export const NoResults = ({
  title = 'No results found in this category',
  description = 'Please, try different keywords, or look in other categories',
}: NoResultsProps) => (
  <div className="flex items-center gap-xxs p-xxs">
    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-100">
      <Search size={20} className="text-gray-500" />
    </div>
    <div className="flex flex-col">
      {title && (
        <h3 className="text-base font-medium text-gray-900">{title}</h3>
      )}
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>
  </div>
)
